import {ServiceBox} from "../../FindService/Service";

export const ServiceListGrid = ({services}) => {
  return <ServiceBox services={services} />;
};
